const features = [
  {
    icon: 'ri-4k-line',
    title: '影院级高清画质',
    desc: '支持4K超清播放，HDR色彩增强技术，让每一帧都如同影院般震撼，完美呈现画面细节与色彩层次。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '智能加速不缓冲',
    desc: '自研P2P加速引擎，多节点CDN智能调度，即使网络波动也能保持流畅播放，告别卡顿与缓冲等待。',
  },
  {
    icon: 'ri-refresh-line',
    title: '同步更新追剧快',
    desc: '与各大平台同步上线最新剧集，24小时内完成更新上架，让你第一时间追到心仪好剧，永远不会落后。',
  },
  {
    icon: 'ri-device-line',
    title: '全设备无缝切换',
    desc: '支持手机、平板、电脑多端同步观看，播放进度云端保存，换设备也不丢失追剧记录，随时随地接着看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-star-line"></i>
            核心优势
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">为什么选择我们</h2>
          <p className="mt-2 text-foreground-500 text-sm">四大核心优势，打造极致追剧体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${item.icon} text-primary-600 text-xl group-hover:text-white transition-colors duration-200`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}